// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-want-to-join',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './want-to-join.html',
})
export class WantToJoin {
  public weLoveItems = signal<string[]>([
    'Seeing the big picture; from a single line of code to production.',
    'Taking ownership of our work and driving it forward.',
    'Keeping things clean and tidy; it always pays off in the long run.',
    'Automating processes, so we can focus on the work that truly matters.',
    'Learning and experimenting with new technologies; our codebases evolve with us.',
    'Leveraging the latest features of our tools; we don’t just upgrade, we make them count.',
    'Sharing knowledge within the team and with the wider community through talks, workshops, and events.',
    'Collaborating through code reviews and being open to fixes and improvements; we know the best solutions come from working together.',
  ]);
  public notOurThingItems = signal<string[]>([
    "Endless meeting ceremonies; we sync when it’s actually needed.",
    "Strict development flows imposed “because the books say so”; we follow a process that works for our team.",
    "One-size-fits-all solutions; not every problem requires a hammer."
  ]);
}
